import { render, staticRenderFns } from "./HolidaysParticipantsPrintList.vue?vue&type=template&id=2ad0b04c&scoped=true&"
import script from "./HolidaysParticipantsPrintList.vue?vue&type=script&lang=ts&"
export * from "./HolidaysParticipantsPrintList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad0b04c",
  null
  
)

export default component.exports